






import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuIcon } from '@/types/type';

@Component
export default class LinkButtonIcon extends Vue {
  @Prop()
  private icon!: MenuIcon;
}
